import { render, staticRenderFns } from "./bulletinBoard.vue?vue&type=template&id=fbdd1c02&scoped=true&"
import script from "./bulletinBoard.vue?vue&type=script&lang=js&"
export * from "./bulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./bulletinBoard.vue?vue&type=style&index=0&id=fbdd1c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdd1c02",
  null
  
)

export default component.exports